import Modal from "react-modal";
import {
  Box,
  CircularProgress,
  circularProgressClasses,
  Stack,
} from "@mui/material";
import { useEffect, useState } from "react";

export function ModalProgress({
  isOpen,
  percent,
}: {
  isOpen: boolean;
  percent: number;
}) {
  const [lastPercent, setLastPercent] = useState(0);

  const animateValue = (
    id: string,
    start: number,
    end: number,
    duration: number
  ) => {
    setLastPercent(end);
    if (start === end) return;
    var range = end - start;
    var current = start;
    var increment = end > start ? 1 : -1;
    var stepTime = Math.abs(Math.floor(duration / range));
    var obj = document.getElementById(id);
    var timer = setInterval(function () {
      current += increment;
      if (obj) {
        obj.innerHTML = String(current) + "%";
      }
      if (current === end) {
        clearInterval(timer);
      }
    }, stepTime);
  };

  useEffect(() => {
    animateValue("countNumber", lastPercent, percent, 700);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [percent]);

  return (
    <>
      <Modal
        isOpen={isOpen}
        className={{
          base: "overlay-cinza",
          afterOpen: "modal-base_after-open",
          beforeClose: "modal-base_before-close",
        }}
        overlayClassName={{
          base: "overlay-base",
          afterOpen: "overlay-base_after-open",
          beforeClose: "overlay-base_before-close",
        }}
        shouldCloseOnOverlayClick={true}
      >
        <Stack
          sx={{
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#00000062",
          }}
        >
          <Box sx={{ position: "relative" }}>
            <CircularProgress
              variant="determinate"
              size={180}
              thickness={4}
              value={100}
              sx={{ color: "#13A66633" }}
            />
            <CircularProgress
              variant="indeterminate"
              disableShrink
              size={180}
              thickness={4}
              sx={{
                left: 0,
                position: "absolute",
                color: "#13A666",
                animationDuration: "550ms",
                [`& .${circularProgressClasses.circle}`]: {
                  strokeLinecap: "round",
                },
              }}
            />

            <Stack
              sx={{
                position: "absolute",
                left: 0,
                top: 0,
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                fontSize: 42,
                fontWeight: 700,
                color: "#13A666",
              }}
            >
              <Box
                id="countNumber"
                sx={{
                  textAlign: "center",
                  fontSize: 46,
                  fontWeight: 700,
                  color: "#13A666",
                  pb: 1,
                }}
              >
                0%
              </Box>
            </Stack>
          </Box>
        </Stack>
      </Modal>
    </>
  );
}
